module.exports = __webpack_public_path__ + "img/logo08.6c2fc23a.png";